export const textoSx = {
    padding: '10px',
    width: '100%'
}
